<template>
  <div class="text center">
	<p>
    	<VueTextGlitch fill="#fefefe" background="#1d1d1d" text="distort_ space"></VueTextGlitch>
	</p>
  </div>
</template>

<script>
import VueTextGlitch from "vue-text-glitch";
export default {
  components: {
    VueTextGlitch
  }
};
</script>
<style scoped>
.text{
	font-size: 3rem;
	font-weight: 300;
}
.center {
  height: 100vh;
  position: relative;
}

.center p {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
